import React, { useState } from 'react';
import DistrictFinder from './district-finder';
import { XIcon } from '@heroicons/react/outline';
import classNames from 'classnames';

const GEOJSON = '/districts/assembly-2022.geojson';

const FILL_MAP = {
  19: '#880E4F',
  17: '#0288D1',
};

const CloseButton = ({ onCloseHandler }) => {
  return (
    <div
      className="p-5 text-slate-500 hover:text-red-500 rounded-full cursor-pointer text-xl sm:px-2"
      onClick={onCloseHandler}
    >
      <XIcon className="w-5 h-5" />
    </div>
  );
};

const DistrictInfo = ({ info, onCloseHandler }) => {
  let innerText;
  try {
    if (info === null) {
      return <div></div>;
    } else if (Object.keys(info.assembly).length === 0) {
      innerText = 'Sorry, something went wrong.';
    } else {
      innerText = `You're in Assembly District ${info.assembly?.district}`;
    }
  } catch (e) {
    console.error('Error rendering district info: ', e);
    innerText = 'Sorry, something went wrong.';
  }
  return (
    <div className="h-[28rem] md:h-[32rem] bg-white flex relative">
      <div className="flex-col">
        <div className="bg-white flex flex-col gap-4 md:flex-row md:gap-6 p-5 md:p-6 relative">
          <div className="w-11/12">{innerText}</div>
        </div>
        <div className="absolute top-1 right-2">
          <CloseButton onCloseHandler={onCloseHandler} />
        </div>
      </div>
    </div>
  );
};

export const AssemblyDistrictFinder = ({ showPadding = true }) => {
  return (
    <div
      className={classNames({
        'sm:mb-10 sm:mt-10 bg-gray-100 shadow-lg px-2 pt-6 pb-3 sm:px-24 sm:pb-4': showPadding,
      })}
    >
      <DistrictFinder
        geoJsonUrl={GEOJSON}
        fillMap={FILL_MAP}
        infoComponent={DistrictInfo}
        allowClick={false}
        fetchRemoteInfo={true}
        headerText="Enter your address to find your district"
        forceTrueCenter={true}
        focusedZoomLevel={13.5}
      />
    </div>
  );
};

export default AssemblyDistrictFinder;
